import { AppState } from "../app.state";
import { ContactDetailsDto } from "../../pages/contact-details/contact-details.component";

export const getContactDetails = (state: AppState): ContactDetailsDto => state.contactDetails;

export const getProfileModalWindow = (state: AppState) => state.contactDetails.isOpen;

export const getProfileStatus = (state: AppState) => state.contactDetails.loadStatus;
